import { CountUp } from 'countup.js'

let tiendasAnimationSeen = false

document.documentElement.style.backgroundColor = '#ededed'

function startTiendasAnimation() {
  const cantidadTiendas = document.getElementById('cantidad-tiendas')
  let countUp = new CountUp(cantidadTiendas, cantidadTiendas.dataset.total, {
    duration: 3.5,
    decimal: ','
  })
  tiendasAnimationSeen = true
  countUp.start()
}

window.addEventListener('load', () => {
  document.getElementById('empezar-gratis').addEventListener('click', function (event) {
    if (window['gtag'])
      gtag('event', 'empezar-gratis', {
        event_category: 'suscripcion',
        event_label: serverExports.pais
      })
  })

  document.querySelectorAll('.empezar-gratis').forEach((element) => {
    element.addEventListener('click', function (event) {
      event.preventDefault()
      document.querySelector('html').classList.add('is-clipped')
      document.getElementById('modal-empezar-gratis').classList.add('is-active')
    })
  })

  document.getElementById('cerrar-empezar-gratis').addEventListener('click', function (event) {
    event.preventDefault()
    document.getElementById('modal-empezar-gratis').classList.remove('is-active')
    document.querySelector('html').classList.remove('is-clipped')
  })

  document.getElementById('solicitud-asesoramiento').addEventListener('click', function (event) {
    event.preventDefault()
    document.getElementById('modal-empezar-gratis').classList.remove('is-active')
    document.getElementById('modal-solicitud-asesoramiento').classList.add('is-active')
  })

  document
    .getElementById('cerrar-solicitud-asesoramiento')
    .addEventListener('click', function (event) {
      event.preventDefault()
      document.getElementById('modal-solicitud-asesoramiento').classList.remove('is-active')
      document.querySelector('html').classList.remove('is-clipped')
    })

  const cerrarNotificacion = document.getElementById('cerrar-notificacion')
  if (cerrarNotificacion)
    cerrarNotificacion.addEventListener('click', function (event) {
      event.preventDefault()
      document.getElementById('modal-notificacion').classList.remove('is-active')
    })

  var observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting === true && !tiendasAnimationSeen) startTiendasAnimation()
    },
    { threshold: [1] }
  )
  observer.observe(document.getElementById('cantidad-tiendas'))

  if (document.getElementById('carrusel')) {
    let glide = new Glide('#carrusel', {
      type: 'carousel',
      perView: 4,
      gap: 25,
      focusAt: 'center',
      autoplay: 2000,
      hoverpause: true,
      breakpoints: {
        800: {
          perView: 2
        },
        480: {
          perView: 1
        }
      }
    })
    glide.mount()
  }
})
